<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-start wrap>
      <v-flex md12>
        <div v-if="loading">Carregando unidades consumidoras...</div>
        <material-card
          color="success"
          title="Unidades Consumidoras"
          text="Unidades Consumidoras cadastrados na plataforma"
          v-if="!loading"
        >
          <v-form ref="form" v-model="valid" lazy-validation v-if="!loading">
            <v-container fill-height fluid grid-list-xl>
              <v-layout>
                <v-flex xs4 md4 class="text-lg-left">
                  <v-text-field
                    v-model="name"
                    label="Nome"
                    class="purple-input"
                    @keyup.enter="_search"
                  />
                </v-flex>
                <v-flex xs4 md4 class="text-lg-left">
                  <v-text-field
                    v-model="installation_number"
                    label="Unidade Consumidora"
                    class="purple-input"
                    _search
                  />
                </v-flex>
                <v-flex xs4 md4 class="text-lg-left">
                  <v-autocomplete
                    :items="filteredPowerPlants"
                    item-text="name"
                    item-value="power_plant_id"
                    label="Planta"
                    v-model="power_plant_id"
                    @keyup.enter="_search"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs4 md4 class="text-lg-left">
                  <v-autocomplete
                    :items="reasonsList"
                    label="UC sob análise"
                    v-model="analysis_reasons"
                    item-text="text"
                    item-value="value"
                    multiple
                    chips
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs2 md2 class="text-lg-left">
                  <v-btn
                    color="success"
                    outline
                    small
                    slot="start"
                    @click="_search"
                    :disabled="!valid || loading_search"
                    :loading="loading_search"
                  >
                    <v-icon left>search</v-icon>Buscar
                  </v-btn>
                </v-flex>
                <v-flex xs2 md2 class="text-lg-left">
                  <v-btn
                    color="tertiary"
                    small
                    outline
                    slot="start"
                    @click="_clear"
                    :disabled="!valid || loading_search"
                  >
                    <v-icon left>clear</v-icon>Limpar
                  </v-btn>
                </v-flex>
                <!-- <v-flex xs2 md2 class="text-lg-right">
                  <div class="text-xs-rigth text-md-rigth text-lg-rigth">
                    <v-btn
                      class="mx-0 font-weight-light"
                      color="primary"
                      slot="end"
                      outline
                      small
                      :disabled="loading || loading_search || loading_export"
                      :loading="loading_export"
                      @click.prevent="openMyDialog"
                      ><v-icon left dark>get_app</v-icon>Exportar</v-btn
                    >
                  </div>
                </v-flex> -->
              </v-layout>
            </v-container>
          </v-form>
          <v-progress-linear
            v-if="loading"
            height="2"
            v-slot:loading
            color="cyan"
            indeterminate
          ></v-progress-linear>
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :rows-per-page-items="[
              {
                text: 'Todos',
                value: -1,
              },
              5,
              10,
              25,
            ]"
            rows-per-page-text="Linhas por página"
            no-data-text="Não há unidades consumidoras cadastradas"
            class="elevation-1"
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <!--<td>{{ item.item.updated_at | formatarData }}</td>-->
              <td>{{ item.name || "" }}</td>
              <!-- <td>{{ item.user? item.user.phone: '' }}</td> -->
              <!-- <td>{{ item.customer_number }}</td> -->
              <td>{{ item.power_plant_id }}</td>
              <td>
                {{
                  item.percentage
                    ? Number.parseFloat(item.percentage).toFixed(2)
                    : "-"
                }}%
              </td>
              <td>
                <v-icon
                  slot="start"
                  color="red"
                  v-if="
                    item.person_type && item.person_type.toLowerCase() === 'pj'
                  "
                  >store</v-icon
                >
                <v-icon slot="start" color="blue" v-else>roofing</v-icon>
                {{ item.installation_number }}
              </td>
              <td class="text-xs-right">
                {{ item.user ? item.user.last_invoice : "" }}
              </td>
              <td>
                <v-chip small dark :color="item.status | formatUCStatusColor">{{
                  item.status || "-" | formatUCStatus
                }}</v-chip>
                <!-- <span
                  :class="item.status === 'canceled' ? 'red--text' : item.status === 'canceling' ? 'orange--text' : ''"
                  >{{ item.status.toUpperCase() }}</span
                > -->
              </td>
              <td class="text-xs-left">
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-if="
                        item.user &&
                        item.user.card_default &&
                        item.user.card_default !== '' &&
                        item.user.payment_type !== 'boleto'
                      "
                      v-on="on"
                    >
                      mdi-credit-card-plus
                    </v-icon>
                    <v-icon v-else v-on="on"
                      >{{ item.user.payment_type | formatPaymentTypeIcon }}
                    </v-icon>
                  </template>
                  <span>{{ item.user.payment_type | formatPaymentType }}</span>
                </v-tooltip>
              </td>
              <!-- <td class="text-xs-right">
                <v-icon
                  left
                  @click="goInvoices(item.user?item.user.customer_id:'')"
                >account_balance_wallet</v-icon>
              </td> -->
              <td>
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-icon @click="customerSelected(item.user)" v-on="on"
                      >visibility</v-icon
                    >
                  </template>
                  <span>Ir aos dados do membro</span>
                </v-tooltip>
              </td>
              <td>
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-icon @click.prevent="goToCustomerCare(item)" v-on="on"
                      >accessibility_new</v-icon
                    >
                  </template>
                  <span>Ir aos dados de atendimento</span>
                </v-tooltip>
              </td>
            </template>
            <v-alert
              v-slot:no-results
              :value="true"
              color="error"
              icon="warning"
              >Sua busca para "{{ search }}" não retornou resultados.</v-alert
            >
            <template v-slot:pageText="items"
              >Linhas {{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }}</template
            >
          </v-data-table>
        </material-card>
      </v-flex>
      <cpnCreateExport />
      <!-- MODAL de Status da Unidade Consumidora -->
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-text class="headline">
            Tem certeza que deseja
            <span class="font-weight-bold">{{
              canceledOrActivatedText()
            }}</span>
            essa unidade consumidora?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="mr-2"
              color="grey darken-1"
              text
              @click="dialog = false"
              >Não</v-btn
            >
            <v-btn color="red darken-1" text @click="changeConsumerUnitStatus()"
              >Sim</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<script>
// import axios from 'axios';
// import firebase from 'firebase/auth'
// import mapState from 'vuex'
import firestore from "../firebase/firestore";
import moment from "moment";
// import { eventBus } from "../main"
import CreateExport from "../components/export/CreateExport";
import statesfile from "@/model/state";
import paisesfile from "@/model/paises";
// import { enviarEmail } from "../services/sendmail"
import { GET_POWERPLANTCOMBO } from "../graphql/powerplants";
import { mapState } from "vuex";
// import {
//   updateUser //getUser,
// } from "../services/users"
// import XLSX from "xlsx"
import { EventBus } from "../utils/event-bus";
import {
  // getConsumerUnits,
  updateConsumerUnit, // getConsumerUnitsCache
} from "../services/consumer_units";
import { reasonsList } from "../../src/utils/reasons.json";

export default {
  data: () => ({
    consumerunits: [],
    name: "",
    power_plant_id: "",
    installation_number: "",
    valid: false,
    data: [
      [
        "Indice",
        "Unidade Consumidora",
        "Num. Cliente",
        "Planta ID",
        "% da Planta",
        // "id",
        "Nome",
        "E-mail",
        // "Telefone",
        // "Cód. de Indicacao",
        // "Última Fatura",
        // "Tipo de Pagamento",
        // "Cartão Cadastrado?",
        "Data de Atualização",
        "Data Criação UC",
        // "Data Assinatura Contrato",
        "Status",
      ],
    ],
    customers: [],
    customer: {},
    totalItemsProcess: 0,
    pagination: {
      rowsPerPage: 25, // -1 for All",
    },
    pagination_before: {},
    items: [],
    items_complete: [],
    totalItems: 0,
    search: "",
    loading: false,
    loading_search: false,
    // loading_export: false,
    dialog: false,
    analysis_reasons: [],
    reasonsList: reasonsList,
    ucToChange: {},
    headers: [
      {
        sortable: false,
        text: "Name",
        value: "item.name",
      },
      {
        sortable: false,
        text: "Planta",
        value: "power_plant_id",
      },
      {
        sortable: false,
        text: "%",
        value: "percentage",
      },
      {
        sortable: false,
        text: "U.C.",
        value: "installation_number",
      },
      {
        sortable: false,
        text: "Faturado em",
        value: "user.last_invoice",
        align: "right",
      },
      {
        text: "Status",
        sortable: false,
      },
      {
        text: "",
        sortable: false,
        name: "user.payment_type",
      },
      // {
      //   text: "",
      //   sortable: false,
      //   name: "invoices"
      // },
      {
        text: "",
        sortable: false,
        name: "edit",
      },
      {
        text: "",
        sortable: false,
        name: "atendimento",
      },
    ],
    showMenu: false,
    x: 0,
    y: 0,
    actions: [
      {
        title: "Proposta enviada",
        icon: "send",
        iconClass: "blue white--text",
        value: 2,
      },
      {
        title: "Contrato Assinado",
        icon: "person",
        iconClass: "amber white--text",
        value: 3,
      },
      {
        title: "Solicitar nova conta",
        icon: "person",
        iconClass: "blue white--text",
        value: 4,
      },
    ],
    states: statesfile.estados,
    paises: paisesfile,
    nameRules: [
      (v) => !!v || "Por favor, informe o nome",
      (v) => v.length <= 10 || "Por favor, preencha seu nome completo.",
    ],
    address: {},
    myDate: {},
    ani_ano: 0,
    ani_mes_fix: 0,
    ani_dia: 0,
    dias31: [],
    dias30: [],
    dias29: [],
    dias28: [],
    meses: [],
    anos: [],
    status: ["Ativo", "Inativo"],
    power_plants: [
      {
        id: "Todas usinas",
        name: "Todas usinas",
      },
    ],
    filterPowerPlant: "Todas usinas",
    plantUsers: [],
  }),
  components: {
    cpnCreateExport: CreateExport,
  },
  computed: {
    ...mapState(["user"]),
    config() {
      return this.$store.state.config;
    },
    filteredPowerPlants() {
      if (
        this.user.group.indexOf("admin") === 0 ||
        this.user.group.indexOf("customer_care") === 0 ||
        this.user.group.indexOf("financial") === 0
      )
        return this.power_plants;

      var PowerPlantArray = [];
      if (this.power_plants && this.user.power_plants) {
        this.power_plants.filter((power_plant) => {
          return this.user.power_plants.filter((power_plant2) => {
            if (power_plant2.power_plant_id === power_plant.power_plant_id) {
              PowerPlantArray.push(power_plant);
            }
          });
        });
      }
      return PowerPlantArray;
    },
    likesAllReasons() {
      return this.reasonsList.length;
    },
    likesSomeReasons() {
      return this.reasonsList.length > 0 && !this.likesAllStatus;
    },
    icon() {
      if (this.likesAllReasons) return "mdi-close-box";
      if (this.likesSomeReasons) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },
  watch: {
    pagination: {
      handler() {
        const {
          // sortBy, descending,
          page,
          rowsPerPage,
        } = this.pagination;

        // console.log('pagination: ', this.pagination)

        // console.log('befor_page: ', this.pagination_before.page)
        // console.log('next_page: ', this.pagination.page)
        // console.log('page: ', this.pagination.page)
        // console.log('page_cont', (this.items_complete.length/rowsPerPage))
        /* 
          Se selecionou página anterior
          Pega os dados direto do array items_complete
          */
        if (
          this.pagination_before &&
          this.pagination_before.page > this.pagination.page
        ) {
          this.loading = true;
          this.items = this.items_complete.slice(
            (page - 1) * rowsPerPage,
            page * rowsPerPage,
          );
          this.loading = false;

          /*
          Se selecionou proxima página, mas a pagina selecionada já foi carregada antes
          Pega os dados direto do array items_complete
          */
        } else if (
          this.pagination_before &&
          this.pagination_before.page <= this.pagination.page &&
          this.pagination.page <= this.items_complete.length / rowsPerPage
        ) {
          this.loading = true;
          this.items = this.items_complete.slice(
            (page - 1) * rowsPerPage,
            page * rowsPerPage,
          );
          this.loading = false;

          // Se a pagina é a mesma não faz nada
        } else if (this.pagination_before.page === this.pagination.page) {
          this.loading = true;
          this.items = this.items_complete.slice(
            (page - 1) * rowsPerPage,
            page * rowsPerPage,
          );
          this.loading = false;

          /*
          Se selecionou proxima página, e a pagina selecionada ainda não foi carregada antes
          Busca os dados no firebase e adiciona ao array os dados firebase
          */
        } else {
          this.pagination_before = this.pagination;
          if (this.last) {
            this.loading = true;
            const {
              // sortBy, descending,
              page,
              rowsPerPage,
            } = this.pagination;
            // await firestore.collection('consumer_units')
            let params = {
              last: this.last,
            };
            if (this.name) {
              params.name = this.name;
            } else if (this.power_plant_id) {
              params.power_plant_id = this.power_plant_id;
            } else if (this.installation_number) {
              params.installation_number = this.installation_number;
            }
            this.getUCs(params)
              // firestore.collection('consumer_units')
              //   // .where('competence', '==', this.competence)
              //   .limit(rowsPerPage || 25)
              //   .orderBy('created_at', descending?'desc':'asc')
              //   .startAfter(this.last)
              .onSnapshot({ includeMetadataChanges: true }, (res) => {
                this.last = res.docs[res.docs.length - 1];
                const changes = res.docChanges();
                if (res.docs.length < this.pagination.rowsPerPage) {
                  this.totalItems =
                    (this.pagination.page - 1) * this.pagination.rowsPerPage +
                    res.docs.length;
                  this.pagination.totalItems = this.totalItems;
                }
                // console.log('changes: ', changes)
                changes.forEach((change) => {
                  // console.log('change.type: ', change.type)
                  if (change.type === "added") {
                    // const customer_id = change.doc.data().user_id
                    firestore
                      .collection("users")
                      .doc(change.doc.data().user_id)
                      .get()
                      .then((user) => {
                        this.items.push({
                          ...change.doc.data(),
                          id: change.doc.id,
                          user: {
                            id: user.id,
                            ...user.data(),
                          },
                        });
                        this.items_complete.push({
                          ...change.doc.data(),
                          id: change.doc.id,
                          user: {
                            id: user.id,
                            ...user.data(),
                          },
                        });
                        this.loading = false;
                      })
                      .catch(() => {
                        this.items.push({
                          ...change.doc.data(),
                          id: change.doc.id,
                        });
                        this.items_complete.push({
                          ...change.doc.data(),
                          id: change.doc.id,
                        });
                        this.loading = false;
                      });
                  } else if (change.type === "modified") {
                    // this.items.push({
                    //     ...change.doc.data(),
                    //     id: change.doc.id,
                    //   })
                    // const customer_id = change.doc.data().user_id
                    // console.log('modified: ', customer_id)
                  } else {
                    this.loading = false;
                  }
                  // var source = res.metadata.fromCache ? "local cache" : "server";
                  // console.log("Data came from " + source);
                });
              });
            if (rowsPerPage > 0) {
              this.items = this.items.slice(
                (page - 1) * rowsPerPage,
                page * rowsPerPage,
              );
            }
          } else {
            this.loading = false;
          }
        }
      },
      deep: true,
    },
  },
  beforeCreate() {
    this.$store.dispatch("setInitialsConfig");
  },
  created() {
    this.loading = true;
    this.items_complete = [];
    this.items = [];
    this.totalItems = this.config.consumer_units.total || 0;
    this.pagination.totalItems = this.config.consumer_units.total || 0;
    // const { sortBy, descending, rowsPerPage } = this.pagination
    const params = {};
    this.getUCs(params).onSnapshot({ includeMetadataChanges: true }, (res) => {
      const changes = res.docChanges();
      this.last = res.docs[res.docs.length - 1];
      if (res.docs.length < this.pagination.rowsPerPage) {
        this.totalItems =
          (this.pagination.page - 1) * this.pagination.rowsPerPage +
          res.docs.length;
        this.pagination.totalItems = this.totalItems;
      }
      changes.forEach((change) => {
        if (change.type === "added") {
          firestore
            .collection("users")
            .doc(change.doc.data().user_id)
            .get()
            .then((user) => {
              this.items.push({
                ...change.doc.data(),
                id: change.doc.id,
                user: {
                  id: user.id,
                  ...user.data(),
                },
              });
              this.items_complete.push({
                ...change.doc.data(),
                id: change.doc.id,
                user: {
                  id: user.id,
                  ...user.data(),
                },
              });
              this.loading = false;
            })
            .catch(() => {
              this.items.push({
                ...change.doc.data(),
                id: change.doc.id,
              });
              this.items_complete.push({
                ...change.doc.data(),
                id: change.doc.id,
              });
              this.loading = false;
            });
        } else if (change.type === "modified") {
          // const customer_id = change.doc.data().user_id
          // console.log('modified: ', customer_id)
        } else {
          this.loading = false;
        }
      });
    });
  },
  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.likesAllReasons) {
          this.reasonsList = [];
        } else {
          this.reasonsList = this.reasonsList.slice().map((item) => item.value);
        }
      });
    },
    goInvoices(customer_id) {
      this.$router.push({
        path: "/unidades-consumidoras/faturas/" + customer_id,
        params: { customer_id: customer_id },
      });
    },
    customerSelected(customer) {
      // console.log(customer)
      this.loading = true;
      EventBus.$emit("userSelected", customer);
      this.$router.push({
        path: "/membro/" + customer.customer_id,
        params: { id: customer.customer_id },
      });
    },
    goToCustomerCare(customer) {
      this.$router.push({
        path:
          "/atendimento/?installation_number=" + customer.installation_number,
      });
    },
    // async enviarEmail(customer, template) {
    //   const data = {
    //     email: customer.email,
    //     name: customer.name,
    //     dynamic_template_data: {
    //       name: customer.name,
    //       email: customer.email
    //     },
    //     template_id: template
    //   }

    //   enviarEmail(data)
    //     .then(() => {
    //       if (customer.emailconta && typeof customer.emailconta === "number") {
    //         customer.emailconta++
    //       } else {
    //         customer.emailconta = 1
    //       }

    //       // console.log('envia_customer:', JSON.stringify(customer))

    //       updateUser(customer.email, customer)
    //         .then(alert("E-mail enviado com sucesso!"))
    //         .catch(error => {
    //           console.error("Erro ao atualizar envio de email do customer. ", error)
    //           alert("Erro ao atualizar envio de email do customer. ", error)
    //         })
    //     })
    //     .catch(error => {
    //       console.error("Erro ao enviar email. ", error)
    //       alert("Ops! Falha ao enviar email.", error)
    //     })
    // },
    // async proposta(select_customer, value) {
    //   // console.log('value_proposta: ', value)
    //   select_customer.step = value
    //   await updateUser(select_customer.email, select_customer)
    //     .then(() => {
    //       this.$nextTick(() => {
    //         // console.log(this.$el.textContent) // => 'atualizado'
    //         alert("Dado atualizado com sucesso!")
    //       })
    //     })
    //     .catch(error => {
    //       console.error("Erro ao atualizar os dados. ", error)
    //       alert("Erro ao atualizar os dados. ", error)
    //     })
    // },
    // newBill(select_customer) {
    //   //Solicita ao usuário nova conta, pois a atual não está legivel
    //   select_customer.step = 1
    //   this.enviarEmail(select_customer, process.env.VUE_APP_SENDGRID_TEMPLATE_NOVACONTA)
    // },
    formatarData: function (value) {
      if (!value) return "-";
      let timestamp = value; // firebase data
      let myDate = new Date(); // date object
      // console.log(timestamp.valueOf().seconds)
      if (timestamp.valueOf().seconds) {
        // myDate = timestamp.toDate()
        myDate = new Date(timestamp.seconds * 1000); // date object
      } else if (timestamp.valueOf()._seconds) {
        myDate = new Date(timestamp._seconds * 1000); // date object
      } else {
        return "-";
      }
      return moment(myDate.toISOString()).format("DD/MM/YYYY");
    },
    getUCs(params) {
      let ref = firestore.collection("consumer_units");

      if (params.name) {
        ref = ref.where("name_insensitive", ">=", params.name.toLowerCase());
      } else if (params.power_plant_id) {
        ref = ref.where("power_plant_id", "==", params.power_plant_id);
      } else if (params.installation_number) {
        ref = ref.where(
          "installation_number",
          "==",
          params.installation_number,
        );
      } else if (params.analysis_reasons) {
        ref = ref.where("under_analysis_reason", "in", params.analysis_reasons);
      }
      ref = ref.limit(this.pagination.rowsPerPage || 25);

      if (params.name) {
        ref = ref.orderBy(
          "name_insensitive",
          this.pagination.descending ? "desc" : "asc",
        );
      } else {
        // ref = ref.orderBy('created_at', this.pagination.descending?'desc':'asc')
        // ref = ref.orderBy('created_at', 'desc')
      }

      if (params.last) {
        ref = ref.startAfter(this.last);
      }
      return ref;
    },
    async _search() {
      this.loading_search = true;
      this.items = [];
      this.items_complete = [];
      this.last = null;
      this.pagination_before = {};

      let params = {};
      if (this.name) {
        params.name = this.name;
      } else if (this.power_plant_id) {
        params.power_plant_id = this.power_plant_id;
      } else if (this.installation_number) {
        params.installation_number = this.installation_number;
      } else if (this.analysis_reasons.length > 0) {
        params.analysis_reasons = this.analysis_reasons;
      }
      this.getUCs(params)
        .get()
        // ref.get()
        .then((ucs) => {
          // console.log('ucs qtde: ', ucs.size)
          this.last = ucs.docs[ucs.docs.length - 1];
          if (ucs.size > 0) {
            if (ucs.size < this.pagination.rowsPerPage) {
              this.totalItems =
                (this.pagination.page - 1) * this.pagination.rowsPerPage +
                ucs.size;
              this.pagination.totalItems = this.totalItems;
            }
            ucs.docs.map(async (snapshot, index) => {
              firestore
                .collection("users")
                .doc(snapshot.data().user_id)
                .get()
                .then((user) => {
                  this.items.push({
                    index,
                    id: snapshot.id,
                    ...snapshot.data(),
                    user: {
                      id: user.id,
                      ...user.data(),
                    },
                  });
                  this.items_complete.push({
                    index,
                    id: snapshot.id,
                    ...snapshot.data(),
                    user: {
                      id: user.id,
                      ...user.data(),
                    },
                  });
                  // this.loading = false;
                })
                .catch(() => {
                  this.items.push({
                    index,
                    id: snapshot.id,
                    ...snapshot.data(),
                  });
                  this.items_complete.push({
                    index,
                    id: snapshot.id,
                    ...snapshot.data(),
                  });
                  // this.loading = false;
                });
              if (ucs.size - 1 === index) {
                this.loading_search = false;
              }
            });
          } else {
            this.loading_search = false;
          }
        })
        .catch((error) => {
          console.error(error);
          this.loading_search = false;
        });
      this.pagination = {
        descending: false,
        page: 1,
        rowsPerPage: 25,
        sortBy: null,
        totalItems: this.totalItems,
      };
      const {
        // sortBy,
        page,
        rowsPerPage,
      } = this.pagination;

      if (rowsPerPage > 0) {
        this.items = this.items.slice(
          (page - 1) * rowsPerPage,
          page * rowsPerPage,
        );
      }
    },
    async _clear() {
      this.loading_search = true;
      // console.log('search: ', this.name.toUpperCase())
      this.items = [];
      this.items_complete = [];
      this.last = null;
      this.pagination_before = {};
      this.name = "";
      this.installation_number = "";
      this.power_plant_id = "";
      this.totalItems = this.config.consumer_units.total;
      this._search();
    },
    // async _export() {
    //   /* convert state to workbook */
    //   this.loading_export = true
    //   const ucs = await firestore
    //     .collection("consumer_units")
    //     .orderBy("created_at", "asc")
    //     .get()
    //   await ucs.docs.map(async (item, index) => {
    //     // let user = {}
    //     if (item.user_id) {
    //       // user = await firestore.collection('users').doc(item.user_id).get()
    //       // console.log(user)
    //       // item.user = user.data()
    //       this.data.push([
    //         index + 1,
    //         item.installation_number,
    //         item.customer_number || "",
    //         item.power_plant_id || "",
    //         item.percentage || 0,
    //         // ucs,
    //         // item.user.customer_id || '',
    //         item.name,
    //         item.email,
    //         // item.user.phone || "",
    //         // item.user.indicator_code || "",
    //         // item.user.last_invoice || "",
    //         // item.user.payment_type === "boleto" ? "boleto" : "cartão de crédito" || "",
    //         // item.user.card_default ? "Sim" : "Não",
    //         this.formatarData(item.updated_at),
    //         this.formatarData(item.created_at),
    //         // this.formatarData(item.user.signedcontract_at ? item.user.signedcontract_at : item.user.created_at),
    //         item.status || ""
    //       ])
    //       if (ucs.size - 1 === index) {
    //         const ws = XLSX.utils.aoa_to_sheet(this.data)
    //         const wb = XLSX.utils.book_new()

    //         const file = "undiades_consumioras_" + this.formatFileName(new Date())
    //         XLSX.utils.book_append_sheet(wb, ws, file)
    //         /* generate file and send to client */
    //         XLSX.writeFile(wb, file + ".xlsx")
    //         this.loading_export = false
    //       }
    //     }
    //     // console.log('data: ', this.data)
    //   })
    // },
    formatFileName(value) {
      if (!value) return "";
      const year = value.getYear();
      const month = value.getMonth() + 1;
      const day = value.getDay();
      const hour = value.getHours();
      const minute = value.getMinutes();
      return day + "" + month + "" + year + "" + hour + "" + minute;
    },
    openModalAndSaveUC(ucToChange) {
      this.dialog = true;
      this.ucToChange = ucToChange;
    },
    // openMyDialog() {
    //   eventBus.$emit("dialog_export", true) // emit the event to the bus
    // },
    changeConsumerUnitStatus() {
      // console.log(this.ucToChange.status)
      if (typeof this.ucToChange.status === "undefined") {
        this.ucToChange.status = "activated";
      }
      this.ucToChange.status =
        this.ucToChange.status == "canceled" ? "activated" : "canceled";
      const status = this.ucToChange.status;
      // console.log(this.ucToChange.installation_number, this.ucToChange.status)
      updateConsumerUnit(this.ucToChange.installation_number, { status });
      this.dialog = false;
    },
    canceledOrActivatedText() {
      return typeof this.ucToChange.status === "undefined" ||
        this.ucToChange.status == "activated"
        ? "DESATIVAR"
        : "ATIVAR";
    },
  },
  filters: {
    formatarData: function (value) {
      if (!value) return "";
      let timestamp = value; // firebase data
      let myDate = new Date(timestamp._seconds * 1000); // date object
      if (typeof myDate !== "object") return "";
      return moment(myDate).format("DD/MM/YYYY");
    },
    formatStep: function (value) {
      var step_text = "";
      if (!value) return "";

      if (value === "0") {
        step_text = "Sem contas";
      } else if (value === "1") {
        step_text = "Gerando propostas";
      } else {
        step_text = "error";
      }
      return step_text;
    },
    filtrarPorUsina: function (customers, filtro, usinas) {
      //Checar se o filtro é necessário
      if (filtro != "Todas usinas") {
        //Obter o objeto usina referente ao filtro
        var usinaFiltroArr = usinas.filter(function (usina) {
          return filtro.includes(usina.id);
        });
        var usinaFiltro = usinaFiltroArr[0];
        return customers.filter(function (customer) {
          //Verificar se o membro está presente no objeto usina
          //Em caso positivo, o array 'aux' resultante terá comprimento diferente de 0
          var aux = usinaFiltro.users.filter(function (usinaUser) {
            return usinaUser.includes(this.userId);
          }, customer);
          if (aux.length != 0) return true;
          else return false;
        });
      } else {
        return customers;
      }
    },
  },
  apollo: {
    powerplants: {
      query: GET_POWERPLANTCOMBO,
      // Optional result hook
      result({ data, loading }) {
        this.power_plants = data.powerplants;
        this.loading = loading;
      },
      // Error handling
      error(error) {
        console.error("We've got an error!", error);
      },
    },
  },
};
</script>
<style scoped>
.zoom {
  transition: transform 0.2s;
  margin: 0 auto;
}

.zoom:hover {
  -ms-transform: scale(1.4); /* IE 9 */
  -webkit-transform: scale(1.4); /* Safari 3-8 */
  transform: scale(1.4);
}
</style>
